// extracted by mini-css-extract-plugin
export default {"header":"DefaultLayout_header__bB0L7"};